import React, { useState } from "react";
import api from "../../utils/api";
import {
  Box,
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Link as MuiLink,
  Container,
} from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { LoginOutlined } from "@mui/icons-material";
import {
  successAlert,
  errorAlert,
  loadingAlert,
  closeAlert,
} from "../../utils/swalConfig";

const Login = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      loadingAlert("Signing in...");
      const response = await api.post("/users/login", formData);

      localStorage.setItem("jwt", response.data.token);
      closeAlert();
      await successAlert("Welcome!", "Successfully logged in");
      navigate("/dashboard");
    } catch (err) {
      closeAlert();
      errorAlert(
        "Login Failed",
        err.response?.data?.message || "Invalid credentials"
      );
    }
  };

  return (
    <Container maxWidth="xs">
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Card sx={{ width: "100%" }}>
          <CardContent sx={{ p: 4 }}>
            <Box sx={{ mb: 3, textAlign: "center" }}>
              <LoginOutlined
                sx={{ fontSize: 40, color: "primary.main", mb: 2 }}
              />
              <Typography variant="h5" gutterBottom>
                Welcome Back
              </Typography>
              <Typography color="text.secondary">
                Sign in to continue to ATKLand
              </Typography>
            </Box>

            <form onSubmit={handleSubmit}>
              <TextField
                fullWidth
                label="Email"
                type="email"
                value={formData.email}
                onChange={(e) =>
                  setFormData({ ...formData, email: e.target.value })
                }
                required
                margin="normal"
              />
              <TextField
                fullWidth
                label="Password"
                type="password"
                value={formData.password}
                onChange={(e) =>
                  setFormData({ ...formData, password: e.target.value })
                }
                required
                margin="normal"
              />
              <Button
                fullWidth
                variant="contained"
                type="submit"
                size="large"
                sx={{ mt: 3 }}
              >
                Sign In
              </Button>
            </form>

            <Box sx={{ mt: 3, textAlign: "center" }}>
              <Typography variant="body2">
                Don't have an account?{" "}
                <MuiLink component={Link} to="/signup">
                  Sign up here
                </MuiLink>
              </Typography>
              <Button
                component={Link}
                to="/forgot-password"
                color="primary"
                sx={{ mt: 1 }}
              >
                Forgot Password?
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};

export default Login;
